let base = {}
base.install = function(Vue, options) {
    // // 获取商品列表
    // Vue.prototype.GoodsGoodsList = function(){
    //   this.request.post('qrcapi/Goods_goodsList',{
    //     sessionId: userList.sessionId,
    //     userId: userList.id,
    //       // goodsCategoryId //不传为全部商品
    //     //  saleStatus//-1,-2 强制下架   0：下架  1：上架
    //     //  pageNo //页码 [一页10条]
    //   }).then(res=>{
    //     console.log(res,'获取商品列表')
    //   })
    // }
    //刷新验证码
    Vue.prototype.reqImg = function() {
            this.axios
                .get(this.url + "qrcapi/ImageCaptca_findImageCaptcha", )
                .then(res => {
                    if (res.data.code == 1) {
                        var imageCaptchaToken = res.data.data.imageCaptchaToken;
                        var imageCaptchaUrl = res.data.data.imageCaptchaUrl;
                        this.imageCaptchaUrl = imageCaptchaUrl;
                        this.imageCaptchaToken = imageCaptchaToken;
                    } else {
                        console.log(codd不为1);
                    }

                })
                .catch(error => {
                    console.log(error);
                    alert("网络错误，不能访问");
                });
        }
        //表单验证
    Vue.prototype.watchLogin = function() {
            var reg = /^[a-zA-Z]{1}([a-zA-Z0-9]|[._]){7,19}$/;

            var regPhone = 11 && /^((13|14|15|17|18)[0-9]{1}\d{8})$/;
            var phoneNumber = this.phoneNumber;
            var passWord = this.passWord;
            if (reg.test(passWord) && this.check && regPhone.test(phoneNumber)) {

                this.successButton = false;
            } else {
                this.successButton = true;

            }
        }
        // 保存cookie
    Vue.prototype.setCookie = function(cName, value, expiredays) {
            var exdate = new Date();
            exdate.setDate(exdate.getDate() + expiredays);
            document.cookie =
                cName +
                "=" +
                encodeURIComponent(value) +
                (expiredays == null ? "" : ";expires=" + exdate.toGMTString()) + ";path=/";
            console.log(cName, value)
        }
        // 获取cookie
    Vue.prototype.getCookie = function(key) {
            if (document.cookie.length > 0) {
                var start = document.cookie.indexOf(key + "=");
                if (start !== -1) {
                    start = start + key.length + 1;
                    var end = document.cookie.indexOf(";", start);
                    if (end === -1) end = document.cookie.length;
                    return decodeURIComponent(document.cookie.substring(start, end));
                }
            }
            return "";
        }
        // 储存表单信息
    Vue.prototype.setUserInfo = function() {
        var that = this;
        // 判断用户是否勾选记住密码，如果勾选，向cookie中储存登录信息，
        // 如果没有勾选，储存的信息为空
        if (that.isRemember) {
            that.setCookie("account", that.phoneNumber);
            // base64加密密码
            that.setCookie("password", that.passWord);
            that.setCookie("remember", that.isRemember);
        } else {
            that.setCookie("account", "");
            that.setCookie("password", "");
        }
    }
    Vue.prototype.setPlace = function(value) {
        // 地图搜索功能

        var that = this;
        var map = new BMap.Map("allmap"); // 创建地图实例
        // var point = new BMap.Point(120.64207, 28.02191); // 创建点坐标
        map.enableScrollWheelZoom(true); //开启鼠标滚轮缩放
        map.addControl(new BMap.NavigationControl()); //左上角，添加默认缩放平移控件
        map.addControl(new BMap.ScaleControl()); // 左上角，添加比例尺
        map.addControl(new BMap.OverviewMapControl());
        var local,
            point,
            marker = null;
        local = new BMap.LocalSearch(map, {
            //智能搜索
            onSearchComplete: fn
        });

        local.search(value);

        function fn() {
            //如果搜索的有结果
            if (local.getResults() != undefined) {
                map.clearOverlays(); //清除地图上所有覆盖物
                if (local.getResults().getPoi(0)) {
                    point = local.getResults().getPoi(0).point; //获取第一个智能搜索的结果
                    map.centerAndZoom(point, 18);
                    marker = new BMap.Marker(point); // 创建标注
                    map.addOverlay(marker); // 将标注添加到地图中
                    marker.enableDragging(); // 可拖拽
                    console.log("当前搜索定位经度:" + point.lng + "纬度:" + point.lat);
                    that.longitude = point.lng;
                    that.latitude = point.lat;

                    //逆解析地址
                    var myGeo = new BMap.Geocoder();
                    myGeo.getLocation(new BMap.Point(point.lng, point.lat), function(
                        result
                    ) {
                        if (result) {
                            // console.log(result.addressComponents.district);区
                            // console.log(result.addressComponents.province);省
                            // console.log(result.addressComponents.city);市

                            for (let i in that.cityData2) {
                                if (
                                    that.cityData2[i].name == result.addressComponents.district
                                ) {
                                    //  console.log(that.cityData2[i].value)
                                    that.districtId = that.cityData2[i].value;
                                }
                            }
                            // console.log(result.addressComponents.province)
                            for (let i in that.cityData1) {
                                if (
                                    that.cityData1[i].name ==
                                    result.addressComponents.province.slice(
                                        0,
                                        result.addressComponents.province.length - 1
                                    )
                                ) {
                                    //  console.log(that.cityData1[i].value)
                                    that.provinceId = that.cityData1[i].value;
                                }
                            }
                            for (let i in that.cityData3) {
                                if (that.cityData3[i].name == result.addressComponents.city) {
                                    //  console.log(that.cityData3[i].value)
                                    that.cityId = that.cityData3[i].value;
                                }
                            }
                        }
                    });
                } else {
                    alert("未匹配到地点!可拖动地图上的红色图标到精确位置");
                }
            } else {
                alert("未找到搜索结果");
            }
        }

    }


};
export default base;


// WEBPACK FOOTER //
// ./src/assets/base.js